var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"breadcrumb"}},[_c('b-breadcrumb',{staticClass:"mb-0",attrs:{"items":_vm.path}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }